import {Component, HostListener, OnInit} from '@angular/core';
import {DefaultDecoder} from "../../../model/default-decoder";
import {DefaultDecoderFilters} from "../../../model/filters/default-decoder-filters";
import {ConfirmationService, MessageService} from "primeng/api";
import {TranslocoService} from "@ngneat/transloco";
import {AuthGuard} from "../../../common/auth-guard.service";
import {CommonMessagesService} from "../../../services/common-messages.service";
import {FiltersService} from "../../../services/filters.service";
import {SortOrder} from "../../../model/sort-order";
import {DefaultDecodersService} from "../../../services/default-decoders.service";

@Component({
  selector: 'app-default-decoders',
  templateUrl: './default-decoders.component.html',
  styleUrls: ['./default-decoders.component.scss']
})
export class DefaultDecodersComponent implements OnInit {

  public defaultDecoders: DefaultDecoder[];
  public totalDefaultDecoders: number;
  public loadingDefaultDecoders: boolean;

  public rows = 10;
  public first = 0;
  public selected = [];

  public types: string[];

  public filtersVisible: boolean;
  public currentFilters: DefaultDecoderFilters;
  public filtersFilled: boolean;

  constructor(private defaultDecodersService: DefaultDecodersService,
              private messageService: MessageService,
              private i18n: TranslocoService,
              private confirmationService: ConfirmationService,
              public authGuardService: AuthGuard,
              private commonMessagesService: CommonMessagesService,
              private filtersService: FiltersService<DefaultDecoderFilters>) {
    this.types = ['jar', 'js', 'process'];
    this.currentFilters = new DefaultDecoderFilters();
  }

  ngOnInit(): void {
    if (this.filtersService.getCurrentFilters(this.constructor.name) !== undefined) {
      this.filtersFilled = true;
    }
    this.defaultDecoders = new Array(this.rows);
    Object.assign(this.currentFilters, this.filtersService.getCurrentFilters(this.constructor.name));
  }

  private loadDefaultDecoders(offset?: number, limit?: number): void {
    this.loadingDefaultDecoders = true;
    this.defaultDecoders = new Array(this.rows);
    this.trimFieldsForm(this.currentFilters);
    this.defaultDecodersService.getDefaultDecoders(offset, limit, this.filtersService.getCurrentFilters(this.constructor.name) === undefined ? this.currentFilters : this.filtersService.getCurrentFilters(this.constructor.name))
      .subscribe(response => {
        this.defaultDecoders = response.defaultDecoders;
        this.totalDefaultDecoders = response.totalElements;
        this.loadingDefaultDecoders = false;
      });
  }

  onPageChange(event): void {
    this.currentFilters.sortField = event.sortField;
    this.currentFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
    this.loadDefaultDecoders(event.first / event.rows, event.rows);
  }

  resetFilters(): void {
    this.currentFilters = new DefaultDecoderFilters();
    this.currentFilters.sortField = 'name';
    this.currentFilters.sortOrder = SortOrder.ASCENDING;
    this.filtersFilled = false;
    this.filtersService.setCurrentFilters(undefined, this.constructor.name);
    this.applyFilters(true);
  }

  applyFilters(reset?: boolean): void {
    this.first = 0;
    if (reset !== true) {
      this.filtersService.setCurrentFilters(this.currentFilters, this.constructor.name);
      this.filtersFilled = true;
    }
    this.loadDefaultDecoders(this.first / this.rows, this.rows);
  }

  confirmAndDelete(defaultDecoder: DefaultDecoder): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => {
      this.deleteDefaultDecoder(defaultDecoder.name);
    });
  }

  deleteDefaultDecoder(name: string): void {
    this.defaultDecodersService.deleteDefaultDecoder(name).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadDefaultDecoders(this.first / this.rows, this.rows);
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status);
    });
  }

  confirmAndDeleteSelected(): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => this.deleteSelected(), true);
  }

  deleteSelected(): void {
    if (this.selected.length === 0) {
      return;
    }
    const names = this.selected.map(item => item.name);

    this.defaultDecodersService.deleteDefaultDecoders(names).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadDefaultDecoders(this.first / this.rows, this.rows);
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status, true);
    });
  }

  trimFieldsForm(filters: DefaultDecoderFilters): void {
    Object.keys(filters).forEach((key) => {
      if (filters[key] !== undefined && typeof filters[key] === 'string') {
        filters[key] = filters[key].trim();
      }
    });
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {
    if (event.key === 'f') {
      this.filtersVisible = true;
    }
    if (event.key === 'Escape') {
      this.filtersVisible = false;
    }
  }

}
